<template>
  <div class="article-box">
    <Breadcrum  :list="breadcrumbList"></Breadcrum>
    <div class="pag-title clearfix" >
        <div v-if="articleClass !== 'consult' && articleClass !== 'referencedata' " class="page-title-name pull-left">{{ listTitle }}</div>
        <div @click="tabsItemClick('/serve/referencedata')" v-if="articleClass == 'consult' || articleClass == 'referencedata'" class="page-title-name pull-left" :class="$route.path === '/serve/consult'?'no-active':''">党建工作</div>
        <div @click="tabsItemClick('/serve/consult')" v-if="articleClass == 'consult' || articleClass == 'referencedata'" class="page-title-name pull-left" :class="$route.path === '/serve/referencedata'?'no-active':''">意见征集</div>

        <!-- <div  v-if="articleClass === 'meeting'" class="page-title-button pull-right">报名记录</div>
        <div v-if="tabsIndex === 4 && articleClass === 'memberintroduction'" @click="membermienRecord()" class="page-title-button pull-right">投稿记录</div>
        <div v-if="tabsIndex === 4 && articleClass === 'memberintroduction'" @click="membermienAdd()" class="page-title-button pull-right" >我要投稿</div> -->
    </div>
    <div class="search-box clearfix">
      <el-form
        :inline="true"
        :model="search"
        label-position="right"
        label-width="0"
        style="text-align: left;"
        class="pull-right"
      >
        <el-form-item>
          <el-input style="width: 300px;" v-model="search.text" size="medium" placeholder="请输入你要搜索的内容"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="medium" icon="el-icon-search" @click="listSearch" class="search-btn">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- <div> -->
      <!-- <div class="list-title">
        <span v-if="articleClass !== 'memberintroduction'" style="font-size: 20px;">{{ listTitle }}</span>
        <div v-else class="pull-left">
          <span
            class="tabs-item tabs-item-bor cursor "
            :class="{'tabs-item-on': tabsIndex === 3}"
            @click="tabsItemClick(3)"
          >会员介绍</span>
          <span
            style="padding-left: 10px;" class="tabs-item cursor"
            :class="{'tabs-item-on': tabsIndex === 4}"
            @click="tabsItemClick(4)"
          >会员风采</span>
        </div>
        <div v-if="articleClass === 'meeting'" class="pull-right tabs-item cursor" style="color: #02A7F0;">报名记录</div>
        <div v-if="tabsIndex === 4 && articleClass === 'memberintroduction'" class="pull-right">
          <router-link to="membermien/add">
            <span
              style="color: #02A7F0;" class="tabs-item tabs-item-bor cursor "
            >我要投稿</span>
          </router-link>
          <router-link to="membermien/record">
            <span
              style="padding-left: 10px;color: #02A7F0;" class="tabs-item cursor"
              @click="tabsItemClick(4)"
            >投稿记录</span>
          </router-link>
        </div>
      </div> -->
      <template  v-if="list.length">
        <ul>
            <li v-for="(item, index) of list" :key="index"  class="news-li news-li-border" :class="item.url ? 'link' : 'no-link'">
              <div class="news-left" style="width: 550px;" @click="itemClick(item)">{{item.title}}</div>
              <div class="news-time">{{item.publishTime}}</div>
            </li>
          </ul>
        <!-- </div> -->
        <el-pagination
          style="text-align: right;padding-top: 20px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40, 50]"
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="pageSize"
          :current-page="pageNo"
          :page-count="totalPage"
          :total="totalCount">
        </el-pagination>
      </template>
      <div class="no-data-img"  v-if="!list.length"></div>
  </div>
</template>

<script lang="js">
import { Estata, ElistText } from '@/assets/model/interface';
import { GetArticleList } from '@/http/api/ArticleApi';
import Breadcrum from '@c/breadcrum/Breadcrum.vue';

export default {
  components: {
    Breadcrum,
  },
  data() {
    return {
      loading: false,
      search: {
        text: '',
      },
      breadcrumbList: [
        { name: '会员服务', path: '/serve' },
        { name: '意见征集', path: '' },
      ],
      list: [],
      totalPage: 0, // 总页数
      totalCount: 0, // 总条数
      pageNo: 1, // 当前页数
      pageSize: 10, // 每页几条
      tabsIndex: 7, // 会员风采 4  会员简介 3
      articleClass: 'consult',
    };
  },
  computed: {
    listTitle() {
      return ElistText[this.articleClass];
    },
  },
  watch: {
    $route(n, o) {
      this.articleClass = n.params.list;
      this.getList();
    },
    articleClass(n, o) {
      if (n) {
        this.tabsIndex = 3;
        this.search.text = '';
        this.pageNo = 1;
        this.breadcrumbList.splice(1, 1);
        this.breadcrumbList.push({
          name: ElistText[n],
          path: '',
        });
      }
    },
  },
  created() {
    console.log(this.$route.params.list);
    this.articleClass = this.$route.params.list;
    this.getList();
  },
  methods: {
    membermienRecord() {
      this.$router.push({ path: '/serve/membermien/record' });
    },
    membermienAdd() {
      this.$router.push({ path: '/serve/membermien/add' });
    },
    // 切换会员简介和会员风采
    tabsItemClick(num) {
      this.$router.push({ path: num });
      // this.tabsIndex = num;
      // this.tabsIndex = num;
      // this.listSearch();
    },
    // 查看文章详情
    itemClick(item) {
      if (item.url) {
        window.open(item.url, '_blank');
      } else {
        const { href } = this.$router.resolve({
          path: '/article/detail',
          query: { type: this.articleClass, articleId: item.id },
        });
        window.open(href, '_blank');
      }
    },
    // 获取文章数据列表
    getList() {
      this.loading = true;
      let cmsType = 3;
      if (this.articleClass === 'memberintroduction') {
        cmsType = this.tabsIndex;
      } else {
        cmsType = Estata[this.articleClass];
        console.log(11111, this.articleClass);
      }
      GetArticleList({
        cmsType,
        keyword: this.search.text,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.loading = false;
        if (res.code === '000') {
          const data = res.result;
          this.totalCount = data.total;
          this.totalPage = data.pages;
          this.pageNo = data.current;
          this.list = data.records;
        }
      });
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getList();
    },
    listSearch() {
      this.pageNo = 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.tabs-item{
  display: inline-block;
  width: 90px;
  font-size: 18px;
  color: #666666;
  // padding-right: 10px;
}
.tabs-item-bor{
  position: relative;
}
.tabs-item-bor::after{
  content: '';
  height: 20px;
  width: 1px;
  background-color: #222222;
  position: absolute;
  top: 10px;
  right: 0;
}
.tabs-item-on{
  font-size: 20px;
  color: #222222;
}
.news-li-border{
  border-bottom: 1px dashed  rgba(233, 233, 233, 1)
}
.news-li{
  position: relative;
  padding: 12px 0px 12px 22px;
  line-height: 16px;
}
// .news-li::before{
  // content: '';
  // height: 6px;
  // width: 6px;
  // border-radius: 6px;
  // background-color: #D8D8D8;
  // position: absolute;
  // top: 50%;
  // left: 7px;
  // margin-top: -3px;
// }
.news-left{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
}
.news-left:hover{
  color: #155BDD;
}
.news-time{
  color: rgba(153, 153, 153, 1);
  font-size: 12px;
  line-height: 12px;
  position: absolute;
  top: 50%;
  margin-top: -6px;
  right: 10px;
}
.search-btn {
  background-color: #7285C4;
}
.no-active {
  border-bottom:none
}
.page-title-button {
  background: none;
}
.no-data-img {
    width: 100%;
    height: 300px;
    background: url("../../assets/images/nodata.png") no-repeat center center;
}
.no-link::before{
  content: '';
  position: absolute;
  width: 20px;
  height: 22px;
  background-image: url("../../assets/images/artical.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  top: 9px;
  left: -4px;
}
.link::before{
  content: '';
  position: absolute;
  width: 20px;
  height: 22px;
  background-image: url("../../assets/images/link.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  top: 9px;
  left: -4px;
}
</style>
